import { Grid } from '@mui/material';
import { UOAH, uopdCls } from '../userOrderProductDetails.classes';

type AccordionPhotoPreviewProps = {
    isOutofStockHeader: boolean;
    isExpanded: boolean;
    isAnimationRunning: boolean;
    items: any[];
};

export const AccordionPhotoPreview = ({
    isOutofStockHeader,
    isExpanded,
    isAnimationRunning,
    items,
}: AccordionPhotoPreviewProps) => {
    if (isExpanded && !isAnimationRunning) {
        return null;
    }

    const visibleItems = items.slice(0, 10);
    const extraCount = items.length > 10 ? items.length - 10 : 0;

    return (
        <Grid
            className={uopdCls(
                `photo-animation ${!isExpanded ? 'photo-show' : 'photo-hide'}`,
                UOAH.photoAnimationGrid,
                isOutofStockHeader ? UOAH.outofStockGrid : undefined
            )}
            style={{
                marginLeft: '10px',
                display: 'flex',
                marginTop: '20px',
                alignItems: 'center',
                height: 'auto',
                gap: '1rem',
            }}
            size={{
                xl: 12,
                sm: 12,
            }}
        >
            {visibleItems.map((item: any, index: number) => (
                <img
                    key={index}
                    src={item.imageUrl}
                    alt=""
                    style={{
                        height: 'auto',
                        width: '50px',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                    }}
                />
            ))}
            {extraCount > 0 && (
                <div
                    className={UOAH.outofStockMoreBubble}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#FFC300',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        color: 'white',
                    }}
                >
                    +{extraCount}
                </div>
            )}
        </Grid>
    );
};
